import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const UsersPage = lazy(() => import("modules/users/Users"));
export default function Users() {
  return (
    <SuspenseWrapper>
      <UsersPage />
    </SuspenseWrapper>
  );
}
